export default __webpack_public_path__ + "static/media/NDk2NTAuanBn.3886ac02.jpg";